const initialState = {
  teams: null,
};

export default function teamReducer(state = initialState, action) {
  switch (action.type) {
    case "GET_TEAMS":
      return {
        ...state,
        teams: action.teams,
      };
    default:
      return {
        ...state,
      };
  }
}
